import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPaymentItem.Save.IRequest;
type Response = Api.Finance.ClaimJobPaymentItem.Save.IResponse;
type Headers = Api.Finance.ClaimJobPaymentItem.Save.IHeaders;
const url = '/api/Finance/ClaimJobPaymentItem';
export default async function claimJobPaymentItemSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
